/**
 * @voltxampere/ui — TVS P6KE6.8A (Sprint 45-4, placeholder)
 *
 * PLACEHOLDER. Transient Voltage Suppressor — bidirectional clamp;
 * şu anki stamp `zener` üzerinden tek-yön breakdown davranış
 * gösterir. Gerçek bidirectional clamp + fast pico-second response
 * Sprint 47+ engine extension #4 ile.
 *
 * Reference: Vishay P6KE6.8A — DO-15. TVS diode, V_RWM = 5.8 V,
 * V_BR = 6.45-7.14 V (typ 6.8 V), I_PP = 88 A pulse, P_PP = 600 W
 * pulse @ 1 ms. ESD + EFT + lightning protection (USB lines, RS-485,
 * CAN bus, automotive 12V rail).
 *
 *   Default mapping → zener schemaType:
 *     saturationCurrent = 1e-12
 *     ideality = 1.5
 *     breakdownVoltage = 6.8
 *
 * Engine zero-diff invariant honored — canonical `zener` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { zener } from "../zener.js";
export const diodeTvsP6ke6v8 = {
    id: "p6ke6v8",
    nameTr: "P6KE6.8A (TVS 6.8V, DO-15, placeholder)",
    nameEn: "P6KE6.8A (TVS 6.8V, DO-15, placeholder)",
    shortcut: "D",
    category: "active",
    viewBox: zener.viewBox,
    terminals: zener.terminals,
    defaultLabel: "D",
    defaultValue: "P6KE6.8A",
    schemaType: "zener",
    defaultParams: { saturationCurrent: 1e-12, ideality: 1.5, breakdownVoltage: 6.8 },
    renderSVG: () => zener.renderSVG(),
};
//# sourceMappingURL=diode-tvs-p6ke6v8.js.map